const selectors = {
  toggleButton: "div.read-more--toggle-btn",
};

export default selectors;
